module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.switch-groups')))]), _vm._v(" "), _c('base-list', {
    attrs: {
      "model": "switch-groups",
      "columns": ['name', 'description'],
      "sModel": "switch-group"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-103115ed!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch-group/SwitchGroupList.vue
// module id = 1121
// module chunks = 2